import type { DisputeItem } from "../../types";

export type DiyDisputeBucket = "in_progress" | "awaiting" | "resolved";

export function normalizeDiyDisputeBucket(status: string): DiyDisputeBucket {
  const s = status.toLowerCase();
  if (s.includes("await")) {
    return "awaiting";
  }
  if (s.includes("resolved") || s.includes("delete")) {
    return "resolved";
  }
  return "in_progress";
}

export function getDisputeBureaus(dispute: DisputeItem): string[] {
  return [
    dispute.equifaxDisputed ? "Equifax" : "",
    dispute.experianDisputed ? "Experian" : "",
    dispute.transUnionDisputed ? "TransUnion" : "",
  ].filter(Boolean);
}

export type ScoreBand = { label: string; chipClass: string };

/** FICO-style bands per spec. */
export function getScoreBand(score: number): ScoreBand {
  if (!score || score < 300) {
    return { label: "No score", chipClass: "bg-slate-700/80 text-slate-400 border border-slate-600" };
  }
  if (score <= 579) {
    return { label: "Poor", chipClass: "bg-red-500/20 text-red-300 border border-red-500/40" };
  }
  if (score <= 669) {
    return { label: "Fair", chipClass: "bg-orange-500/20 text-orange-200 border border-orange-500/40" };
  }
  if (score <= 739) {
    return { label: "Good", chipClass: "bg-amber-500/20 text-amber-200 border border-amber-500/40" };
  }
  return { label: "Excellent", chipClass: "bg-emerald-500/20 text-emerald-200 border border-emerald-500/40" };
}

export function formatDeltaPts(delta: number | null | undefined): string {
  if (delta === null || delta === undefined || Number.isNaN(delta)) {
    return "+0 pts";
  }
  if (delta === 0) {
    return "+0 pts";
  }
  const sign = delta > 0 ? "+" : "";
  return `${sign}${delta} pts`;
}
